import React from "react";

const MultiOnlyNodePicker = ({ isChecked }: any) => {
  console.log(isChecked);
  return <div>MultiOnlyNodePicker</div>;
};

export default MultiOnlyNodePicker;
